import { render, staticRenderFns } from "./DynamicContentFilters.vue?vue&type=template&id=39c95f2d"
import script from "./DynamicContentFilters.vue?vue&type=script&lang=js"
export * from "./DynamicContentFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports